import AttachServiceModal from "@/features/leads/components/view-lead/components/Ongoing/components/AttachServiceModal";
import type { NicheModalProps } from "../nicheRegistry";

// Close no longer refetches: useAttachVariant refreshes deal/lead caches on
// success, and a plain cancel changed nothing. In create mode (no deal yet)
// the modal creates the lead's first deal with the picked variant.
export default function AttachServiceModalAdapter({
  open,
  onClose,
  child,
  createForLead,
}: NicheModalProps) {
  return (
    <AttachServiceModal
      open={open}
      onClose={onClose}
      dealId={child?.id ?? null}
      dealName={child?.name || createForLead?.name || "Deal"}
      createForLead={createForLead ?? null}
    />
  );
}
